import * as imageAPIUtil from 'utils/api/images';
import * as embedAPIUtil  from 'utils/api/embed';
import { displayErrorMessage, parseHTMLText } from '@insticator/insticator-ui'; // iui-utils
import {batchActions} from 'redux-batched-actions';
import { addTemporaryUserImage } from './image_status';

export const ADD_CONTENT = 'ADD_CONTENT';
export const SELECT_CONTENT = 'SELECT_CONTENT';
export const SET_SELECTED_CONTENT_PROPERTY = 'SET_SELECTED_CONTENT_PROPERTY';
export const SET_SHARED_CONTENT_PROPERTY = 'SET_SHARED_CONTENT_PROPERTY';
export const SET_STORY_PROPERTY = 'SET_STORY_PROPERTY';
export const SET_QB_PROPERTY = 'SET_QB_PROPERTY';
export const ADD_OPTION = 'ADD_OPTION';
export const REMOVE_OPTION = 'REMOVE_OPTION';
export const UPDATE_OPTION_PROPERTY = 'UPDATE_OPTION_PROPERTY';
export const REMOVE_BACKGROUND_IMAGE = 'REMOVE_BACKGROUND_IMAGE';
export const SET_ACTIVE_SELECTION = 'SET_ACTIVE_SELECTION';
export const SET_SELECTED_IMAGE = 'SET_SELECTED_IMAGE';
export const SET_CUSTOM_IMAGE = 'SET_CUSTOM_IMAGE';
export const SETTING_CUSTOM_IMAGE = 'SETTING_CUSTOM_IMAGE';


export const SETTING_CUSTOM_EMAIL_IMAGE = 'SETTING_CUSTOM_EMAIL_IMAGE';
export const SET_CUSTOM_EMAIL_IMAGE = 'SET_CUSTOM_EMAIL_IMAGE';
export const SET_CUSTOM_EMAIL_PREVIEW_IMAGE = 'SET_CUSTOM_EMAIL_PREVIEW_IMAGE';


export const SET_PREVIEW_IMAGE = 'SET_PREVIEW_IMAGE';
export const SELECT_CORRECT_OPTION = 'SELECT_CORRECT_OPTION';
export const RECEIVE_CONTENT_DATA = 'RECEIVE_CONTENT_DATA';
export const RECEIVE_SORTED_CONTENT_DATA = 'RECEIVE_SORTED_CONTENT_DATA';
export const UPDATE_CONTENT_DATA = 'UPDATE_CONTENT_DATA';
export const RESET_CONTENT_STATUS = 'RESET_CONTENT_STATUS';
export const REORDER_CONTENTS = 'REORDER_CONTENTS';
export const DELETE_CONTENT = 'DELETE_CONTENT';
export const INVALIDATE_SELECTED_CONTENT = 'INVALIDATE_SELECTED_CONTENT';
export const INVALIDATE_ACTIVE_ADD_ON = 'INVALIDATE_ACTIVE_ADD_ON';
export const UPDATE_NO_LIVE_CONTENT = 'UPDATE_NO_LIVE_CONTENT';
export const SET_CONTENT_CHANGE_STATE = 'SET_CONTENT_CHANGE_STATE';
export const DISCARD_CONTENT_CHANGES = 'DISCARD_CONTENT_CHANGES';
export const DISCARD_ADD_ON_CHANGES = 'DISCARD_ADD_ON_CHANGES';
export const SET_CONTENT_TYPE = 'SET_CONTENT_TYPE';
export const SET_CURRENT_UNIQUE_PROPERTY = 'SET_CURRENT_UNIQUE_PROPERTY';
export const SET_EMAIL_COLLECTION_PROPERTY = 'SET_EMAIL_COLLECTION_PROPERTY';
export const SORT_ANSWER_OPTIONS = 'SORT_ANSWER_OPTIONS';
export const FETCHING_SORTED_EMBED_ANALYTICS = 'FETCHING_SORTED_EMBED_ANALYTICS';
// export const INVALIDATE_MULTIPLE_CONTENTS = 'INVALIDATE_MULTIPLE_CONTENTS';


/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > CONTENT STATUS: ACTION CREATORS ~~~~~~~~~~ ========== */

export const addContent = (contentType, placement) => ({
    type: ADD_CONTENT,
    contentType,
    placement
});
export const selectContent = contentId => ({
    type: SELECT_CONTENT,
    contentId
});
export const setContentType = contentType => ({
    type: SET_CONTENT_TYPE,
    contentType
});
export const setSelectedContentProperty = (isSharedProperty, property, value) => ({ //this action updates a property of the currently selected content
    type: SET_SELECTED_CONTENT_PROPERTY,
    isSharedProperty,
    property,
    value
});
export const setSharedContentProperty = (contentId, property, value) => ({
    type: SET_SHARED_CONTENT_PROPERTY,
    contentId,
    property,
    value
});
export const setCurrentUniqueProperty = (contentId, property, value) => ({
    type: SET_CURRENT_UNIQUE_PROPERTY,
    contentId,
    property,
    value
});

export const setUniqueEmailCollectionProperty = (property, value) => ({
    type: SET_EMAIL_COLLECTION_PROPERTY,
    property,
    value
});

export const setQBProperty = (contentId, property, value) => ({
    type: SET_QB_PROPERTY,
    contentId,
    property,
    value
});
export const setStoryProperty = (contentId, property, value) => ({
    type: SET_STORY_PROPERTY,
    contentId,
    property,
    value
});
export const updateOptionProperty = (contentId, optionId, propertyName, value) => ({
    type: UPDATE_OPTION_PROPERTY,
    contentId,
    optionId,
    propertyName,
    value
});
export const addOption = contentId => ({
    type: ADD_OPTION,
    contentId
});
export const removeOption = (contentId, optionId) => ({
    type: REMOVE_OPTION,
    contentId,
    optionId
});
export const setActiveSelection = selection => ({
    type: SET_ACTIVE_SELECTION,
    selection
});
export const setSelectedImage = (provider, imageId, imageURL) => ({
    type: SET_SELECTED_IMAGE,
    provider,
    imageId,
    imageURL
});
export const setCustomImage = (contentId, optionId, imageURL) => ({
    type: SET_CUSTOM_IMAGE,
    contentId,
    optionId,
    imageURL
});
export const customImageSuccess = (contentId, optionId, imageURL) => batchActions([
    setCustomImage(contentId, optionId, imageURL),
    settingCustomImage(false)
]);
export const customImageFail = (err, contentId, optionId) => batchActions([
    receiveError(err),
    settingCustomImage(false),
    displayErrorMessage('There was an issue uploading your image'),
    setCustomImage(contentId, optionId, null)
]);

const customEmailCollectionBackgroundSuccess = (imageURL) => batchActions([settingCustomEmailCollectionBackground(false), setCustomEmailCollectionImage(imageURL)]);
const customEmailCollectionBackgroundFailure = () => batchActions([settingCustomEmailCollectionBackground(false), displayErrorMessage('There was an issue uploading your image')]);

const settingCustomEmailCollectionBackground = status => ({
    type: SETTING_CUSTOM_EMAIL_IMAGE,
    status
});

export const setCustomEmailCollectionImage = imageURL => ({
    type: SET_CUSTOM_EMAIL_IMAGE,
    imageURL
});
export const setCustomEmailCollectionPreviewImage = imageURL => ({
    type: SET_CUSTOM_EMAIL_PREVIEW_IMAGE,
    imageURL
});

export const settingCustomImage = status => ({
    type: SETTING_CUSTOM_IMAGE,
    status
});
export const setPreviewImage = imageURL =>({
    type: SET_PREVIEW_IMAGE,
    imageURL
});
export const selectCorrectOption = optionId => ({
    type: SELECT_CORRECT_OPTION,
    optionId
});
export const receiveContentData = contents => ({
    type: RECEIVE_CONTENT_DATA,
    contents,
});
export const receiveSortedContentData = contents => ({
    type: RECEIVE_SORTED_CONTENT_DATA,
    contents
});
export const fetchingSortedEmbedAnalytics = status => ({
    type: FETCHING_SORTED_EMBED_ANALYTICS,
    status
});
export const updateContentData = contents => ({
    type: UPDATE_CONTENT_DATA,
    contents
});
export const resetContentState = ({ setInitialContentId }) => ({
    type: RESET_CONTENT_STATUS,
    setInitialContentId
});
export const reorderContents = (liveContents, inactiveContents) => ({
    type: REORDER_CONTENTS,
    liveContents,
    inactiveContents
});
export const deleteContent = contentId => ({
    type: DELETE_CONTENT,
    contentId
});
export const updateNoLiveContent = bool =>({
    type: UPDATE_NO_LIVE_CONTENT,
    bool
});
export const invalidateSelectedContent = () => ({
    type: INVALIDATE_SELECTED_CONTENT
});
export const invalidateActiveAddOn = (addOn) => ({
    type: INVALIDATE_ACTIVE_ADD_ON,
    addOn
});
export const setContentChangeState = contentChangeState => ({
    type: SET_CONTENT_CHANGE_STATE,
    contentChangeState
});
export const discardContentChanges = () => ({
    type: DISCARD_CONTENT_CHANGES
});

export const discardAddOnChanges = () => ({
    type: DISCARD_ADD_ON_CHANGES
});

export const sortOptions = (contentId, options) => ({
    type: SORT_ANSWER_OPTIONS,
    contentId,
    options
});

export const removeBackgroundImage = contentId => ({
    type: REMOVE_BACKGROUND_IMAGE,
    contentId
});

// export const invalidateMultipleContents = () => ({
//     type: INVALIDATE_MULTIPLE_CONTENTS
// });
const receiveError = (error) => {
    console.log('contentStatusActionsError', error);
};


/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > CONTENT STATUS: THUNKS ~~~~~~~~~~ ========== */

export const uploadCustomImage =  (contentId, optionId, accountUUID, imageFile) => dispatch => {
    dispatch(settingCustomImage(true));
        imageAPIUtil.uploadImage(accountUUID, imageFile, false, 'CUSTOMIZE')
            .then(response => {
                const imageFile = response.data[0];
                dispatch(addTemporaryUserImage(imageFile))
                dispatch(customImageSuccess(contentId, optionId, imageFile))
              },
                err => (customImageFail(err, contentId, optionId)))
};

export const uploadEmailCollectionBackgroundImage = (accountUUID, imageFile) => dispatch => {
    dispatch(settingCustomEmailCollectionBackground(true));
    imageAPIUtil.uploadImage(accountUUID, imageFile, false, 'ADD_ONS')
        .then(response => dispatch(customEmailCollectionBackgroundSuccess(response.data[0])))
        .catch(err => console.log(err) || dispatch(customEmailCollectionBackgroundFailure()))
};

const getContentByProperty = (response, property) => {
    return response.filter(currentResource => currentResource.property === property)
}

const autopopulateStoryContent = (property, resource, contentId, dispatch) => {
    //if the resource exists, i.e the array of resources is non-empty
    if (resource.length > 0){
        switch (property){
            case 'title':
                  // Note: "titleResource[0].content.slice(0, 150)" this code is to make sure the title length stays less tan or equal
                  // to 150. Whenever we decide to change the limit of the title, we need to change here as well.
                  //use util to parse html entity codes from title text
                 dispatch(setStoryProperty(contentId, 'title', parseHTMLText(resource[0].content.slice(0,150))));
                 return true;
            case 'image':
                 dispatch(setCurrentUniqueProperty(contentId, 'backgroundImageURL', resource[0].content));
                 dispatch(setCurrentUniqueProperty(contentId, 'imageProvider', 'STORY'));
                 return true;
            default:
                return false;
        }
    }
    return false;
}

export const applyStoryURL = (contentId, url) => dispatch => {
    dispatch(setSharedContentProperty(contentId, 'storyURLDataReceived', false));
    embedAPIUtil.retrievePageResource(url)
        .then(response => {
            dispatch(setSharedContentProperty(contentId, 'storyURLDataReceived', true));
            //filter results of query for desired page contents
            const titleResource = getContentByProperty(response.data, 'title');
            const imageResource = getContentByProperty(response.data, 'image');
            //autopopulate the story content if the resources are valid.
            const autoPopulatedTitle = autopopulateStoryContent('title', titleResource, contentId, dispatch);
            const autoPopulatedImage = autopopulateStoryContent('image', imageResource, contentId, dispatch);
            //message the user if both the story image and url couldn't be autopopulated
            if (!autoPopulatedImage && !autoPopulatedTitle) {
                dispatch(displayErrorMessage('Sorry, this website will not allow us to autopopulate this story.'));
            }
        })
        .catch((error) => {
        dispatch(displayErrorMessage("Sorry, we encountered an issue while autopopulating this story."));
        dispatch(setSharedContentProperty(contentId, 'storyURLDataReceived', true));})
}
